import React, { useState } from "react";
import { Marker } from "@react-google-maps/api";
import InfoWindowPosicao from "./InfoWindowPosicao";
import { pinSvg } from "./pinSvg";

const UltimaPosicaoValida = ({ points, isLast }) => {
  const [clicked, setClicked] = useState(null);
  return (
    <>
      {points.map((p) => {
        return (
          <Marker
            key={p.id}
            position={p.longitudeLatitude}
            icon={pinSvg("rgb(228, 160, 119)")}
            clickable={true}
            onClick={() => setClicked(p)}
          />
        );
      })}
      <InfoWindowPosicao
        item={clicked}
        handleClose={() => setClicked(null)}
        canDelete={false}
        isLast={isLast}
      />
    </>
  );
};

export default UltimaPosicaoValida;
